module.exports = __webpack_public_path__ + "img/9.6dfa82e4.svg";